<template>
  <div>
    <h1 class="h1">Accounts</h1>

    <AccountSummary :stats="stats" />

    <div class="my-6" v-if="accounts.length">
      <div class="flex py-3 font-semibold">
        <ColumnSort class="w-4/12" column="name" @sort="setSort">Account</ColumnSort>
        <ColumnSort class="w-4/12" column="created_by" @sort="setSort">Gemaakt door</ColumnSort>
        <ColumnSort class="w-1/12" column="is_active" @sort="setSort">Actief</ColumnSort>
        <ColumnSort class="w-1/12" column="users_count" @sort="setSort">Users</ColumnSort>
        <ColumnSort class="w-2/12" column="verified_at" @sort="setSort">Geactiveerd</ColumnSort>
      </div>
      <div
        class="flex py-3 border-t border-gray-200 hover:bg-gray-100"
        v-for="account in accounts"
        :key="account.id"
      >
        <div class="w-4/12">
          <router-link
            :to="{ name: 'admin.accounts.show', params: { id: account.id } }"
          >{{ account.name }}</router-link>
        </div>
        <div class="w-4/12">{{ account.created_by ? account.created_by.name : '-' }}</div>
        <div class="w-1/12 flex items-center pl-4">
          <div
            class="bg-gray-300 rounded-full h-2 w-2"
            :class="{ 'bg-green-500': account.is_active }"
          ></div>
        </div>
        <div class="w-1/12 pl-4">{{ account.users_count ? account.users_count : '-' }}</div>
        <div class="w-2/12">
          <template v-if="account.verified_at">{{ account.verified_at | formatDay }}</template>
        </div>
      </div>
    </div>
    <Pagination :meta="meta" />
  </div>
</template>

<script>
import { get } from "@/api";
import { removeEmptyKeys, isEqual } from "@/functions.js";
import Pagination from "@/components/Pagination";
import ColumnSort from "@/components/ColumnSort";
import AccountSummary from "@/components/AccountSummary";

export default {
  components: {
    Pagination,
    ColumnSort,
    AccountSummary
  },

  metaInfo() {
    return { title: "Accounts" };
  },

  data() {
    return {
      accounts: [],
      filters: {},
      sort: "id.desc",
      page: 1,
      stats: {},
      meta: {
        total: ""
      }
    };
  },

  beforeRouteEnter(to, from, next) {
    get("/admin/accounts", to.query).then(response =>
      next(vm => vm.setData(response.data))
    );
  },

  methods: {
    setSort(sort) {
      this.sort = sort;

      this.loadData();
    },

    loadData() {
      let query = removeEmptyKeys({
        ...this.filters,
        sort: this.sort,
        page: this.page
      });

      if (!isEqual(query, this.$route.query)) this.$router.replace({ query });

      get(this.$route.path, query).then(response =>
        this.setData(response.data)
      );
    },

    setData(data) {
      this.accounts = data.data;
      let { current_page, last_page, total } = data;
      this.meta = { current_page, last_page, total };
      this.stats = data.stats;
    }
  }
};
</script>